/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminbypasslimits2Inputs */

const en_adminbypasslimits2 = /** @type {(inputs: Adminbypasslimits2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bypass limits`)
};

const de_adminbypasslimits2 = /** @type {(inputs: Adminbypasslimits2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limits umgehen`)
};

/**
* | output |
* | --- |
* | "Bypass limits" |
*
* @param {Adminbypasslimits2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const adminbypasslimits2 = /** @type {((inputs?: Adminbypasslimits2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminbypasslimits2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_adminbypasslimits2(inputs)
	return de_adminbypasslimits2(inputs)
});
export { adminbypasslimits2 as "adminBypassLimits" }